import { render, staticRenderFns } from "./FooterTopCarousel.vue?vue&type=template&id=70157fbf&"
import script from "./FooterTopCarousel.vue?vue&type=script&lang=js&"
export * from "./FooterTopCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports